const studentTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'name',
    name: '姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'birthday',
    name: '出生日期'
  },
  {
    value: 'real_name',
    name: '家长姓名'
  },
  {
    value: 'phone',
    name: '家长手机号'
  }
];

const teacherTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'real_name',
    name: '教师姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'contract_type',
    name: '教师类型'
  },
  {
    value: 'org_full_names',
    name: '任职部门'
  },
  {
    value: 'telephone',
    name: '手机'
  }
];

const staffTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'real_name',
    name: '职工姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'org_name',
    name: '职工部门'
  },
  {
    value: 'telephone',
    name: '手机'
  }
];

const regTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'username',
    name: '用户名'
  },
  {
    value: 'real_name',
    name: '姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'phone',
    name: '手机'
  }
];
const otherTable = [
  {
    option: {
      type: 'selection'
    }
  },
  {
    value: 'contact_name',
    name: '学员姓名'
  },
  {
    value: 'gender',
    name: '性别'
  },
  {
    value: 'birthday',
    name: '出生日期'
  },
  {
    value: 'parent_name',
    name: '家长姓名'
  },
  {
    value: 'parent_phone',
    name: '手机'
  }
];

export {
  studentTable, teacherTable, staffTable, regTable, otherTable
};
